/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _getGlobal = require("../../getGlobal");
var globalObject = (0, _getGlobal.getGlobal)();
var document = globalObject ? globalObject.document : null;
var scrollbarWidth;
var hideNativeScrollbarWidth;
var _default = function _default(hideNativeScrollbarIfPossible) {
  if (hideNativeScrollbarIfPossible) {
    if (hideNativeScrollbarWidth !== undefined) {
      return hideNativeScrollbarWidth;
    }
  } else {
    if (scrollbarWidth !== undefined) {
      return scrollbarWidth;
    }
  }
  var result;
  if (document) {
    var div = document.createElement('div');
    var divStyle = div.style;
    if (hideNativeScrollbarIfPossible) {
      div.className = 'inovua--hide-native-scroll-if-possible';
    }
    divStyle.width = '100px';
    divStyle.height = '100px';
    divStyle.position = 'absolute';
    divStyle.visibility = 'hidden';
    divStyle.boxSizing = 'content-box';
    divStyle.top = '-99999px';
    divStyle.overflow = 'scroll';
    divStyle.MsOverflowStyle = 'scrollbar';
    document.body.appendChild(div);
    var inner = document.createElement('div');
    div.appendChild(inner);
    result = div.offsetWidth - inner.offsetWidth;
    document.body.removeChild(div);
  } else {
    result = 0;
  }
  if (hideNativeScrollbarIfPossible) {
    hideNativeScrollbarWidth = result;
  }
  return result;
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/packages/getScrollbarWidth/index.js
// module id = 47
// module chunks = 0